import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.body};
    color: ${({ theme }) => theme.colors.text};
    font-family: ${({ theme }) => theme.font};
    transition: all 0.50s linear;
    padding: 5rem 20rem;
  }


  a {
    color: ${({ theme }) => theme.colors.link.text};
    cursor: pointer;
  }

  button {
    border: 0;
    display: inline-block;
    padding: 12px 24px;
    font-size: 0.8rem;
    margin-top: 5px;
    cursor: pointer;
    background-color:#002244;
    color: #FFFFFF;
    border-radius: 0.3rem;
    text-transform: uppercase;
    font-family: ${({ theme }) => theme.font};
  }

  button.btn {
    background-color: ${({ theme }) => theme.colors.button.background};
    color: ${({ theme }) => theme.colors.button.text};
    float: right;
  }
  h1 {
    margin: 0 auto;
  }

  h1, h2, p {
    font-weight: lighter;
  }
  
`;
